import React, { useEffect, useState, useCallback } from 'react';

const API = process.env.REACT_APP_API_URL || '/api';

export default function DadStatus() {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await fetch(`${API}/status`);
      const d = await r.json();
      setData(d);
    } catch {
      setData(null);
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 15 * 1000);
    return () => clearInterval(t);
  }, [load]);

  if (!data) return null;

  const busy  = data.status === 'busy';
  const color = busy ? '#e87a7a' : '#7ae8b8';

  // Human-readable "since X"
  let since = '';
  if (data.updated_at) {
    try {
      const dt   = new Date(data.updated_at + 'Z');
      const mins = Math.round((Date.now() - dt.getTime()) / 60000);
      if      (mins < 1)   since = 'just now';
      else if (mins === 1) since = '1 min ago';
      else if (mins < 60)  since = `${mins} min ago`;
      else                 since = `${Math.round(mins / 60)}h ago`;
    } catch {}
  }

  return (
    <div style={{
      ...s.wrap,
      background:   busy ? 'rgba(232,122,122,0.07)'  : 'rgba(122,232,184,0.06)',
      borderColor:  busy ? 'rgba(232,122,122,0.35)'  : 'rgba(122,232,184,0.3)',
    }}>
      <div style={{
        ...s.dot,
        background:  color,
        boxShadow:   `0 0 8px ${color}, 0 0 18px ${color}44`,
        animation:   busy ? 'none' : 'dadpulse 2.5s ease-in-out infinite',
      }} />

      <div style={s.info}>
        <span style={{ ...s.label, color }}>
          {busy ? '● DAD IS IN A MEETING' : '● DAD IS FREE'}
        </span>
        {since && <span style={s.sub}>Status set {since}</span>}
      </div>

      <style>{`
        @keyframes dadpulse {
          0%,100% { opacity:1; transform:scale(1);    }
          50%      { opacity:.5; transform:scale(.75); }
        }
      `}</style>
    </div>
  );
}

const s = {
  wrap: {
    display: 'flex', alignItems: 'center', gap: 12,
    padding: '10px 18px', borderRadius: 'var(--radius-sm)',
    border: '1px solid', flexShrink: 0, transition: 'all 0.5s ease',
  },
  dot: {
    width: 14, height: 14, borderRadius: '50%',
    flexShrink: 0, transition: 'all 0.5s ease',
  },
  info: { display: 'flex', flexDirection: 'column', gap: 2 },
  label: {
    fontFamily: 'var(--font-mono)', fontSize: '0.72rem',
    fontWeight: 600, letterSpacing: '0.14em', transition: 'color 0.5s ease',
  },
  sub: {
    fontFamily: 'var(--font-mono)', fontSize: '0.58rem',
    color: 'var(--text-dimmer)', letterSpacing: '0.06em',
  },
};
